export default __webpack_public_path__ + "static/media/home_bottom_img_PC_Cn.3840e13a.webp";